import { useCreditStore } from '../stores/creditStore'

import { registerSessionReset } from '@/features/auth'

/** Credits are ACCOUNT-scoped, never workspace-scoped, so there is deliberately no workspace
 *  watch here: dropping the balance on every workspace switch would refetch it for no reason and
 *  flash the slot panel's empty state. `creditStore` owns the account edge itself
 *  (`watch(accountId)` → `reset()` + refetch); this adds the one edge that watch cannot see on
 *  its own — an explicit session teardown, independent of the order in which account state is
 *  cleared during logout. */
export function registerCreditsLifecycle(): () => void {
  const store = useCreditStore()
  return registerSessionReset(() => store.reset())
}
